import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';
import { Menu, X, Building2 } from 'lucide-react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const { t, isRTL } = useLanguage();

  const navLinks = [
    { label: t('nav.about'), href: '#about' },
    { label: t('nav.facilities'), href: '#facilities' },
    { label: t('nav.spaces'), href: '#spaces' },
    { label: t('nav.gallery'), href: '#gallery' },
    { label: t('nav.testimonials'), href: '#testimonials' },
    { label: t('nav.location'), href: '#location' },
    { label: t('nav.contact'), href: '#contact' },
  ];

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      data-testid="main-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? 'backdrop-blur-xl bg-[#0B1120]/80 border-b border-white/10 shadow-lg shadow-black/20'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <div className="flex items-center justify-between h-16 md:h-20">
          <a href="#" className="flex items-center gap-3 group" data-testid="logo-link">
            <div className="w-9 h-9 bg-[#D4AF37] rounded-sm flex items-center justify-center group-hover:bg-[#FCE69C] transition-colors">
              <Building2 className="w-5 h-5 text-[#020617]" />
            </div>
            <span className="text-lg font-light text-[#F8FAFC] font-['Cormorant_Garamond'] tracking-tight">Khan Complex</span>
          </a>

          <nav className="hidden md:flex items-center gap-6">
            {navLinks.map(link => (
              <a
                key={link.href}
                href={link.href}
                data-testid={`nav-${link.href.slice(1)}`}
                className="text-sm text-[#94A3B8] hover:text-[#D4AF37] transition-colors duration-300 font-['Outfit'] tracking-wide"
              >
                {link.label}
              </a>
            ))}

            <Link
              to="/admin/login"
              data-testid="nav-admin-link"
              className="text-sm px-5 py-2 bg-transparent border border-white/20 text-[#F8FAFC] rounded-sm hover:border-[#D4AF37] hover:text-[#D4AF37] transition-all duration-300 font-['Outfit']"
            >
              {t('nav.admin')}
            </Link>
          </nav>

          <button
            data-testid="mobile-nav-toggle"
            className="md:hidden p-2 text-[#F8FAFC]"
            onClick={() => setMobileOpen(!mobileOpen)}
          >
            {mobileOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-[#0B1120]/95 backdrop-blur-xl border-b border-white/10">
          <nav className="px-6 py-4 space-y-3">
            {navLinks.map(link => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setMobileOpen(false)}
                className="block text-[#94A3B8] hover:text-[#D4AF37] transition-colors py-2 font-['Outfit']"
              >
                {link.label}
              </a>
            ))}
            <Link
              to="/admin/login"
              onClick={() => setMobileOpen(false)}
              className="block text-[#D4AF37] font-medium py-2 font-['Outfit']"
            >
              {t('nav.adminPortal')}
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}
